import { API_ENDPOINTS, API_ERROR_MESSAGES } from "../constants/api";
import { apiFetch } from "./apiClient";

export async function fetchCurrentUser(authToken) {
  const response = await apiFetch(API_ENDPOINTS.auth.me, {
    authToken,
    cache: "no-store",
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.currentUserReadFailed);
  }

  if (!response.ok || !result.success) {
    throw new Error(result?.message || API_ERROR_MESSAGES.currentUserLoadFailed);
  }

  return result;
}
